/** @format */

export const PrintMedium = ({color}) => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M19.875 9.375H4.125C2.6751 9.375 1.5 10.5521 1.5 12V15.9375C1.5 16.6622 2.08775 17.25 2.8125 17.25H4.125V21.1875C4.125 21.9122 4.71275 22.5 5.4375 22.5H18.5625C19.2872 22.5 19.875 21.9122 19.875 21.1875V17.25H21.1875C21.9122 17.25 22.5 16.6622 22.5 15.9375V12C22.5 10.5521 21.3229 9.375 19.875 9.375ZM17.25 19.875H6.75V15.9375H17.25V19.875ZM19.2188 13.6406C18.6753 13.6406 18.2344 13.1997 18.2344 12.6562C18.2344 12.112 18.6753 11.6719 19.2188 11.6719C19.7622 11.6719 20.2031 12.112 20.2031 12.6562C20.2031 13.2018 19.7643 13.6406 19.2188 13.6406ZM6.75 4.125H16.1631L17.25 5.21232V8.0625H19.875V4.66846C19.875 4.32048 19.7366 3.98678 19.4905 3.74068L17.6345 1.88473C17.3895 1.63843 17.0531 1.5 16.7086 1.5H5.4375C4.71316 1.5 4.125 2.08775 4.125 2.8125V8.0625H6.75V4.125Z"
                fill={color}
            />
        </svg>
    );
};
